"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EsriColors = _interopRequireDefault(require("./EsriColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalciteTheme = {
  palette: {
    // ┌───────────┐
    // │ Grayscale │
    // └───────────┘
    white: '#ffffff',
    offWhite: _EsriColors.default.Calcite_Gray_100,
    lightestGray: _EsriColors.default.Calcite_Gray_200,
    lighterGray: _EsriColors.default.Calcite_Gray_350,
    lightGray: _EsriColors.default.Calcite_Gray_400,
    gray: _EsriColors.default.Calcite_Gray_450,
    darkGray: _EsriColors.default.Calcite_Gray_500,
    darkerGray: _EsriColors.default.Calcite_Gray_550,
    darkestGray: _EsriColors.default.Calcite_Gray_600,
    offBlack: _EsriColors.default.Calcite_Gray_650,
    black: _EsriColors.default.Calcite_Gray_700,
    transparentWhite: 'rgba(255, 255, 255, 0.7)',
    opaqueWhite: 'rgba(255, 255, 255, 0.8)',
    transparentOffWhite: 'rgba(0, 0, 0, 0.1)',
    transparentDarkerGray: 'rgba(0, 0, 0, 0.3)',
    transparentOffBlack: 'rgba(0, 0, 0, 0.45)',
    transparentBlack: 'rgba(0, 0, 0, 0.75)',
    opaqueBlack: 'rgba(0, 0, 0, 0.85)',
    // ┌────────────┐
    // │ Brand Blue │
    // └────────────┘
    Brand_Blue_100: _EsriColors.default.Brand_Blue_100,
    //  previously blue 14
    Brand_Blue_150: _EsriColors.default.Brand_Blue_150,
    // previously blue 13
    Brand_Blue_200: _EsriColors.default.Brand_Blue_200,
    // "Esri Blue", previously blue 12
    Brand_Blue_250: _EsriColors.default.Brand_Blue_250,
    // previously blue 11
    // ┌───────────┐
    // │ UI Colors │
    // └───────────┘
    lightestBlue: _EsriColors.default.Calcite_Blue_100,
    lighterBlue: _EsriColors.default.Calcite_Blue_150,
    lightBlue: _EsriColors.default.Calcite_Blue_250,
    blue: _EsriColors.default.Calcite_Highlight_Blue_350,
    darkBlue: _EsriColors.default.Calcite_Highlight_Blue_400,
    darkerBlue: '#052942',
    lightestGreen: _EsriColors.default.Calcite_Green_100,
    lightGreen: _EsriColors.default.Calcite_Green_150,
    green: _EsriColors.default.Calcite_Green_250,
    darkGreen: _EsriColors.default.Calcite_Green_a200,
    darkGreen200: _EsriColors.default.Calcite_Green_200,
    lightestRed: _EsriColors.default.Calcite_Red_100,
    lightRed: _EsriColors.default.Calcite_Red_150,
    red: _EsriColors.default.Brand_Red_100,
    darkRed: _EsriColors.default.Calcite_Red_a200,
    darkRed200: _EsriColors.default.Calcite_Red_200,
    lightestOrange: _EsriColors.default.Calcite_Orange_a100,
    lightOrange: _EsriColors.default.Calcite_Orange_a150,
    orange: _EsriColors.default.Calcite_Orange_a200,
    darkOrange: _EsriColors.default.Calcite_Orange_a250,
    lightestYellow: _EsriColors.default.Calcite_Yellow_100,
    lightYellow: _EsriColors.default.Calcite_Yellow_150,
    yellow: _EsriColors.default.Calcite_Yellow_200,
    darkYellow: _EsriColors.default.Calcite_Yellow_a150,
    lightestPurple: _EsriColors.default.Calcite_Purple_100,
    lightPurple: _EsriColors.default.Calcite_Purple_150,
    purple: _EsriColors.default.Calcite_Purple_200,
    darkPurple: _EsriColors.default.Calcite_Purple_a150,
    lightestBrown: _EsriColors.default.Calcite_Brown_100,
    lightBrown: _EsriColors.default.Calcite_Brown_150,
    brown: _EsriColors.default.Calcite_Brown_250,
    darkBrown: _EsriColors.default.Calcite_Brown_a200
  },
  type: {
    // Header Family
    avenirTracking: 0,
    avenirFamily: '"Avenir Next W01", "Avenir Next W00", "Avenir Next", "Avenir", "Helvetica Neue", sans-serif',
    // Code Family
    codeTracking: 0,
    codeFamily: '"Consolas", "Andale Mono", "Lucida Console", "Monaco", monospace',
    // Icon Family
    iconTracking: 0,
    iconFamily: "\n      font-family: 'calcite-ui';\n      speak: none;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      display: inline-block;\n      text-decoration: none;\n    }",
    // Structural
    ratio: 1.414,
    mediumRatio: 1.33,
    smallRatio: 1.25,
    bodySize: '1rem',
    smallSize: '0.85rem',
    indent: '1em'
  },
  // ┌──────────────┐
  // │ UI Variables │
  // └──────────────┘
  transition: '150ms linear',
  transitionDuration: '150ms',
  easingFunc: 'linear',
  boxShadow: '0 0 16px 0 rgba(0,0,0,.05)',
  drawerWidth: '280px',
  borderRadius: 0,
  // ┌─────────────┐
  // │ TYPE COLORS │
  // └─────────────┘
  typeColor: _EsriColors.default.Calcite_Gray_650,
  linkColor: _EsriColors.default.Calcite_Highlight_Blue_350,
  linkHover: _EsriColors.default.Calcite_Highlight_Blue_400,
  // ┌──────────────┐
  // │ Breakpoints  │
  // └──────────────┘
  small: '480px',
  medium: '860px',
  large: '1450px',
  // ┌────────────────────┐
  // │ Grid Configuration │
  // └────────────────────┘
  prefix: '',
  vwRatio: '0.95',
  containerWidth: '1450px',
  maxWidth: '0.95 * 100vw',
  columnGutter: '1rem',
  // Grid Fallback Options
  ie8Support: false,
  columnGutterFallback: '20px',
  containerWidthFallback: '960px',
  // Medium
  largeClass: 'large',
  largeColumnCount: '24',
  // Default
  defaultColumnCount: '24',
  // Medium
  mediumClass: 'tablet',
  mediumColumnCount: '12',
  // Small
  smallClass: 'phone',
  smallColumnCount: '6',
  // Rhythm
  horizontalRange: '4',
  verticalRange: '6',
  baseline: '1.55rem'
};
var _default = CalciteTheme;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/CalciteThemeProvider/CalciteTheme.js
// module id = 357
// module chunks = 0